<template>
  <div class="max-result-editor">
    <label for="maxresult">Max result</label><input id="maxresult" class="maxresult" v-model="maxresult" />
    <span class="errorMsg">{{ errorMsg }}</span>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'MaxResultEditor',
  components: {}
})
class MaxResultEditor extends Vue {
  errorMsg = ''

  timeoutSave = 0

  cancelTimeoutSave() {
    this.timeoutSave && clearTimeout(this.timeoutSave)
    this.timeoutSave = 0
  }

  get maxresult() {
    return this.user.maxresult
  }

  set maxresult(value) {
    this.cancelTimeoutSave()
    this.timeoutSave = setTimeout(
      function(v) {
        let newMaxresult = parseInt(v)
        this.$fetch.put('/users/current/maxresult', { maxresult: newMaxresult }).then(
          () => {
            let newUser = { ...this.user }
            newUser.maxresult = newMaxresult
            this.saveUser(newUser)

            this.errorMsg = 'saved'
          },
          (err) => {
            console.log('ko', err)
            this.errorMsg = err.cause
          }
        )
      }.bind(this),
      800,
      value
    )
  }
}

export default MaxResultEditor
</script>

<style scoped lang="less">
.max-result-editor {
  display: flex;
  flex-direction: row;
}
</style>
